import React from 'react';
import PropTypes from 'prop-types';

import SSRAwareQuery from './SSRAwareQuery';

export const TranslationsContext = React.createContext({});

const translationsProviderPropTypes = {
  // The GraphQL query
  query: PropTypes.object,
  children: PropTypes.node,
};
export function TranslationsProvider({ query, children }) {
  return (
    <SSRAwareQuery query={query}>
      {({ loading, error, data }) => {
        if (loading) {
          return null;
        }

        if (error) {
          throw error;
        }

        if (data && (!data.application || !data.application.translations)) {
          throw new Error(
            `You need to supply a translation query to "withTranslation" or to "TranslationProvider". The provided query is not a translation query: ${query.loc.source.body}`
          );
        }

        const {
          application: { translations },
        } = data;

        return (
          <TranslationsContext.Provider value={translations}>
            {children}
          </TranslationsContext.Provider>
        );
      }}
    </SSRAwareQuery>
  );
}
TranslationsProvider.propTypes = translationsProviderPropTypes;

export function withTranslations(query, WrappedComponent) {
  return function TranslationsHOC(props) {
    return (
      <TranslationsProvider query={query}>
        <WrappedComponent {...props} />
      </TranslationsProvider>
    );
  };
}

export default TranslationsContext;
